import "../styles/Footer.css"

function Footer() {
    return (
        <section className="footer">
            <h5>Wild Violet Counseling, LLC</h5>      
            <p className="mb-1">Lauren Shuler, LCSW • Licensed Clinical Social Worker (LCSW)</p>      
            {/* <p>lauren@wildvioletcounseling.com</p>   
            <p>Phone: (615) 200-0576</p> */}
            <p className="mb-1">
              © 2025 Wild Violet Counseling, LLC. All rights
              reserved.
            </p>
        </section>
    )
};

export default Footer;